import {API_URL, authHeaders, jsonHeaders} from "./index";

const NETWORK_ERROR = "Impossible de contacter le serveur. Vérifiez votre connexion et réessayez.";

async function safeJson(promise) {
    try {
        const res = await promise;
        return await res.json();
    } catch {
        return {error: NETWORK_ERROR};
    }
}

export function apiAdminListCampaigns() {
    return safeJson(fetch(`${API_URL}/admin/campaigns`, {headers: authHeaders()}));
}

// FormData : le navigateur pose lui-même le Content-Type multipart (avec sa frontière), jamais jsonHeaders().
export function apiAdminCreateCampaign(formData) {
    return safeJson(fetch(`${API_URL}/admin/campaigns`, {method: "POST", headers: authHeaders(), body: formData}));
}

// Du JSON pour des champs seuls ; un FormData quand un nouveau fichier part avec eux (une seule requête :
// le serveur enregistre tout ou rien).
export function apiAdminUpdateCampaign(id, payload) {
    const isForm = payload instanceof FormData;
    return safeJson(fetch(`${API_URL}/admin/campaigns/${id}`, {
        method: "PUT",
        headers: isForm ? authHeaders() : jsonHeaders(),
        body: isForm ? payload : JSON.stringify(payload),
    }));
}

export function apiAdminDeleteCampaign(id) {
    return safeJson(fetch(`${API_URL}/admin/campaigns/${id}`, {method: "DELETE", headers: authHeaders()}));
}

export function apiAdminCampaignPreviewLink(id) {
    return safeJson(fetch(`${API_URL}/admin/campaigns/${id}/preview-link`, {method: "POST", headers: authHeaders()}));
}

export function apiAdminListCampaignAudit() {
    return safeJson(fetch(`${API_URL}/admin/campaigns/audit`, {headers: authHeaders()}));
}
